import { DefaultPageState } from "../../../common/models/StoreDefaultModel";

export type GrueMaterialItemData = {};

export const initialGrueMaterialPageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
